import { useBillModalLauncher } from '~/components/BillModal/hooks/useBillModalLauncher';
import { useCreateAdHoc } from './useCreateAdHoc';
export const useStartAdHocBill = ()=>{
    const { openAdHocBill } = useBillModalLauncher();
    const { createAdHoc, isCreatingAdHoc } = useCreateAdHoc();
    const startAdHocBill = (param)=>{
        let { contactId, existingAdHocRelationshipId, onOpened } = param;
        if (existingAdHocRelationshipId != null) {
            openAdHocBill(existingAdHocRelationshipId);
            onOpened();
            return;
        }
        if (!contactId) return;
        createAdHoc(contactId, {
            onSuccess: (param)=>{
                let { relationshipId } = param;
                openAdHocBill(relationshipId);
                onOpened();
            }
        });
    };
    return {
        startAdHocBill,
        isCreatingAdHoc
    };
};
